// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1KHal","icon":"Button_icon__2SIFi","iconOnly":"Button_iconOnly__1WLrH","outlined":"Button_outlined__1bNQ9","contained":"Button_contained__qhrG5"};